import React from 'react';
import PropTypes from 'prop-types';

import KeyBoardSelector from 'components/KeyBoardSelector';

import SuggestedItem from 'components/form/SuggestedTimes/SuggestedItem';
import SuggestedItemSeparator from 'components/form/SuggestedTimes/SuggestedItemSeparator';

const SuggestedTimes = ({
  t,
  className,
  options,
  handleChange,
  listenerElement,
  scrollToHourOnOpen,
}) =>
  !!options.length && (
    <KeyBoardSelector
      scrollToElementOnOpen={scrollToHourOnOpen}
      listenerElement={listenerElement}
      className={className}
      propagatedPropsOnClick={['value', 'diffDay']}
    >
      {options.map((time) =>
        time.isSection ? (
          <SuggestedItemSeparator key="separator" noSelectWithKeyBoard>
            {t('next_day')}
          </SuggestedItemSeparator>
        ) : (
          <SuggestedItem
            key={`${time.raw}_${time.diffDay}`}
            value={time.raw}
            diffDay={time.diffDay}
            onClick={handleChange}
            scrollOnOpen={
              scrollToHourOnOpen && time.raw === '05:00' && !time.diffDay
            }
          >
            {time.raw}
            {time.subText && (
              <span className="suggested-aclaration"> {t(time.subText)}</span>
            )}
          </SuggestedItem>
        )
      )}
    </KeyBoardSelector>
  );

SuggestedTimes.propTypes = {
  activeItemRef: PropTypes.func.isRequired,
  activeItem: PropTypes.number,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  handleChange: PropTypes.func,
  t: PropTypes.func,
};

SuggestedTimes.defaultProps = {
  className: '',
  options: [],
  activeItem: null,
  handleChange: () => {},
  t: () => {},
};

export default SuggestedTimes;
